import React from 'react'
import { Box, Modal } from '@mui/material'
import { ModalContent } from '../../../common/components'
import { t } from 'i18next'
import { type SelectionProduct, type ProjectDto, type SystemInfoDto } from '../../../common/services'
import HlleaModal from './modalHllea'
import KeyTranslation from '../../../common/KeyTranslation.json'

interface HlleaModalProps {
  open: boolean
  onClose: () => void
  project?: ProjectDto
  systemData?: SystemInfoDto
  systemDatarefetch?: any
  product?: SelectionProduct[] | null
}

export default function ContainerHlleaModal ({ open, onClose, project, systemData, systemDatarefetch, product }: HlleaModalProps): JSX.Element {
  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t(KeyTranslation.System_BaseComponents)}>
          {
            <HlleaModal
              open={open}
              onClose={onClose}
              title={t(KeyTranslation.Common_ChooseHLLEA)}
              project={project}
              systemData={systemData}
              systemDatarefetch={systemDatarefetch}
              product={product}
            />
          }
        </ModalContent>
      </Box>
    </Modal>
  )
}
